<script setup>
import { defineProps } from "vue";

const props = defineProps({
  boxColor: String,
  title: String,
  description: String,
  routerTo: { type: String, default: "dashboard" },
  icon: String,
});
</script>
<template>
  <div class="col-lg-4 col-6">
    <div class="small-box" :class="props.boxColor">
      <div class="inner">
        <h4>{{ title }}</h4>
        <p>{{ description }}</p>
      </div>
      <div class="icon">
        <font-awesome-icon :icon="['fas', props.icon]" aria-hidden="true" />
      </div>
      <router-link :to="`${props.routerTo}`" class="small-box-footer">
        <font-awesome-icon :icon="['fas', 'circle-arrow-right']" />
      </router-link>
    </div>
  </div>
</template>
